import { render, staticRenderFns } from "./innovation.vue?vue&type=template&id=7c4f3686&scoped=true"
import script from "./innovation.vue?vue&type=script&lang=js"
export * from "./innovation.vue?vue&type=script&lang=js"
import style0 from "./innovation.vue?vue&type=style&index=0&id=7c4f3686&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4f3686",
  null
  
)

export default component.exports